import React from 'react';
import { colorPalette, fontWeightPalette, fontSizePalette } from 'utils/styleConstants';


export const createInputStyle = ({
  inputWidth,
  fontColor,
  theme,
  height,
  small,
  backgroundColor,
  borderRadius,
  paddingLeft,
  fontSize,
  hasFeedback,
  noBorder,
  feedbackColor,
}: {
  inputWidth: string;
  fontColor?: string;
  theme: any;
  height?: string;
  small?: boolean;
  backgroundColor?: string;
  borderRadius?: string;
  paddingLeft?: string;
  fontSize?: number;
  hasFeedback?: boolean;
  noBorder?: boolean;
  feedbackColor?: string;
}): React.CSSProperties => ({
  fontFamily: 'Roboto',
  width: inputWidth,
  color: fontColor || (theme?.colorPalette.isDarkMode ? theme.colorPalette.grey.grey10 : theme.colorPalette.black),
  height: height ?? (small ? 18 : 30),
  backgroundColor:
    backgroundColor ?? (theme?.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.white),
  borderRadius: borderRadius ? `${borderRadius}` : small ? 9 : 3,
  fontWeight: small ? fontWeightPalette.light : fontWeightPalette.regular,
  paddingLeft: paddingLeft ?? 5,
  fontSize: fontSize ? `${fontSize}px` : '12px',
  border:
    hasFeedback && !noBorder
      ? `1px solid ${feedbackColor ?? theme?.statusColors.error}`
      : noBorder
      ? 'none'
      : `1px solid ${theme?.colorPalette.isDarkMode ? theme.colorPalette.grey.grey4 : theme.colorPalette.grey.grey5}`,
});

export const createFeedbackLabelStyle = (feedbackColor?: string): React.CSSProperties => ({
  fontFamily: 'Roboto',
  fontSize: fontSizePalette.xxSmall,
  color: feedbackColor ?? colorPalette.red,
  margin: '3px 0 0 3px',
  textAlign: 'right',
  position: 'absolute',
  right: 0,
});

export const getClassName = (disabled?: boolean, noBorder?: boolean): string => {
  if (disabled) return 'datePicker-input-disabled';
  if (noBorder) return 'datePicker-input-hover-noBorder';
  return 'datePicker-input-hover';
};

export const generateYearsArray = (yearRange: { start: number; end: number }): number[] =>
  Array.from({ length: yearRange.end - yearRange.start + 1 }, (_, i) => yearRange.start + i);
